<div class="emma-multi-input">
    <div
        [@fadeScaleInOut]
        class="form-group m-form__group m-form__group--md row"
        *ngFor="let input of inputs; index as index"
    >
        <div class="col-md-12">
            <div [ngClass]="{ 'input-group': allowRemove && !readonly }">
                <emma-input
                    [name]="this.name ? this.name + '__' + index : ''"
                    [ngModel]="input.value"
                    (ngModelChange)="onChangeInput(index, $event)"
                    ($enter)="onEnterInput(index)"
                    ($blur)="onBlur()"
                    [disabled]="disabled"
                    [readonly]="readonly"
                    [required]="true"
                    [type]="type"
                    [autofocus]="!input.value"
                    [placeholder]="placeholder"
                ></emma-input>
                <ng-container *ngIf="allowRemove && !readonly && (!required || index)">
                    <button
                        (blur)="onBlur()"
                        (click)="onRemove(index)"
                        class="btn btn-metal m-btn--icon"
                        type="button"
                        [disabled]="disabled"
                    >
                        <span class="m--font-danger">
                            <i class="la la-trash" aria-hidden="true"></i>
                            <span i18n>Eliminar</span>
                        </span>
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
    <div
        *ngIf="values.length > 0 && createButton && !readonly"
        [@fadeScaleInOut]
        class="m--margin-top-15 m--margin-bottom-15 m-form__separator"
    ></div>
    <div
        *ngIf="createButton && !readonly"
        [@fadeScaleInOut]
        class="form-group m-form__group m-form__group--md m-form__group--last"
    >
        <button emmaButton color="metal" [isWide]="true" [hasIcon]="true" (click)="onAddButton()">
            <span>
                <i class="la la-plus-circle" aria-hidden="true"></i>
                <span>{{ createButton }}</span>
            </span>
        </button>
    </div>
</div>
